import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8f894e4a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dialog_content_view" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "dialog_text" }, "删除后，该账号将不再拥有企业权限和卡片剪辑权限，请谨慎操作", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "dialog_text_tips" }, "注：该账号创建的卡片依然有效，超级管理员和其他管理员可继续编辑", -1))
const _hoisted_4 = { class: "dialog_action_bg" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("button", {
        class: "dialog_button dialog_sure",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.sureButtonClick && _ctx.sureButtonClick(...args)))
      }, "确认删除"),
      _createElementVNode("button", {
        class: "dialog_button dialog_cancel",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.cancelButtonClick && _ctx.cancelButtonClick(...args)))
      }, "返回")
    ])
  ]))
}